import React from 'react';
import './InactivityWarning.css';

const InactivityWarning = ({ timeLeft, onStayLoggedIn }) => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;

    const handleStayLoggedIn = async () => {
        try {
            const response = await fetch('https://apiprov.conduto.com.ec/api/refresh', {
                method: 'POST',
                credentials: 'include'
            });

            if (response.ok) {
                const data = await response.json();
                if (data.access_token) {
                    localStorage.setItem('token', data.access_token);
                    localStorage.setItem('tokenTimestamp', Date.now().toString());
                }
                onStayLoggedIn();
            } else {
                onStayLoggedIn();
            }
        } catch (error) {
            onStayLoggedIn();
        }
    };

    return (
        <div className="inactivity-warning-overlay">
            <div className="inactivity-warning-modal">
                <div className="warning-header">
                    <svg className="warning-icon" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                    </svg>
                    <h3>Sesión por expirar</h3>
                </div>

                <div className="warning-body">
                    <p>Tu sesión se cerrará en:</p>
                    <p className="countdown">
                        {minutes}:{seconds.toString().padStart(2, '0')}
                    </p>
                    <p>¿Deseas continuar?</p>
                </div>

                <div className="warning-actions">
                    <button
                        className="btn-stay-logged"
                        onClick={handleStayLoggedIn}
                        autoFocus
                    >
                        Continuar sesión
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InactivityWarning;